/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressDto,
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    ContactPersonDto,
    ContactPersonDtoFromJSON,
    ContactPersonDtoFromJSONTyped,
    ContactPersonDtoToJSON,
    PhoneDto,
    PhoneDtoFromJSON,
    PhoneDtoFromJSONTyped,
    PhoneDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateContractorCommand
 */
export interface UpdateContractorCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorCommand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorCommand
     */
    name?: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateContractorCommand
     */
    headquarterAddress?: AddressDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateContractorCommand
     */
    postalAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorCommand
     */
    email?: string | null;
    /**
     * 
     * @type {PhoneDto}
     * @memberof UpdateContractorCommand
     */
    phone?: PhoneDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorCommand
     */
    taxnumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorCommand
     */
    companyregisterNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractorCommand
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractorCommand
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractorCommand
     */
    repairmanEmailOfTaskAssignment?: boolean;
    /**
     * 
     * @type {Array<ContactPersonDto>}
     * @memberof UpdateContractorCommand
     */
    contactPersons?: Array<ContactPersonDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateContractorCommand
     */
    townIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateContractorCommand
     */
    documentIds?: Array<string> | null;
}

export function UpdateContractorCommandFromJSON(json: any): UpdateContractorCommand {
    return UpdateContractorCommandFromJSONTyped(json, false);
}

export function UpdateContractorCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractorCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'headquarterAddress': !exists(json, 'headquarterAddress') ? undefined : AddressDtoFromJSON(json['headquarterAddress']),
        'postalAddress': !exists(json, 'postalAddress') ? undefined : AddressDtoFromJSON(json['postalAddress']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : PhoneDtoFromJSON(json['phone']),
        'taxnumber': !exists(json, 'taxnumber') ? undefined : json['taxnumber'],
        'companyregisterNumber': !exists(json, 'companyregisterNumber') ? undefined : json['companyregisterNumber'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'repairmanEmailOfTaskAssignment': !exists(json, 'repairmanEmailOfTaskAssignment') ? undefined : json['repairmanEmailOfTaskAssignment'],
        'contactPersons': !exists(json, 'contactPersons') ? undefined : (json['contactPersons'] === null ? null : (json['contactPersons'] as Array<any>).map(ContactPersonDtoFromJSON)),
        'townIds': !exists(json, 'townIds') ? undefined : json['townIds'],
        'documentIds': !exists(json, 'documentIds') ? undefined : json['documentIds'],
    };
}

export function UpdateContractorCommandToJSON(value?: UpdateContractorCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'headquarterAddress': AddressDtoToJSON(value.headquarterAddress),
        'postalAddress': AddressDtoToJSON(value.postalAddress),
        'email': value.email,
        'phone': PhoneDtoToJSON(value.phone),
        'taxnumber': value.taxnumber,
        'companyregisterNumber': value.companyregisterNumber,
        'isDeleted': value.isDeleted,
        'isActive': value.isActive,
        'repairmanEmailOfTaskAssignment': value.repairmanEmailOfTaskAssignment,
        'contactPersons': value.contactPersons === undefined ? undefined : (value.contactPersons === null ? null : (value.contactPersons as Array<any>).map(ContactPersonDtoToJSON)),
        'townIds': value.townIds,
        'documentIds': value.documentIds,
    };
}


